import type { WaterfallProvider } from "../types/contacts-providers";

export const ACTIVE_PROVIDERS: WaterfallProvider[] = [
    {
        name: "Similarweb",
        domain: "similarweb.com",
        descriptionKey: "si.pages.contacts_waterfall.provider.similarweb.description",
        mode: "managed",
        managedOnly: true,
        creditCost: "si.pages.contacts_waterfall.provider.similarweb.credit_cost",
    },
];

export const COMING_SOON_PROVIDERS: WaterfallProvider[] = [
    {
        name: "SmartE",
        domain: "smarte.pro",
        descriptionKey: "si.pages.contacts_waterfall.provider.smarte.description",
        mode: "disabled",
    },
    {
        name: "FullEnrich",
        domain: "fullenrich.com",
        descriptionKey: "si.pages.contacts_waterfall.provider.fullenrich.description",
        mode: "disabled",
    },
];
